export default __webpack_public_path__ + "static/media/mixkit-software-interface-back-2575.d5d8ec22.wav";